import { cloneDeep } from "lodash";
import { v4 } from "uuid";
import userACL from "../../../store/access";
import { createSegmap, editSegmap } from "../data/actions";
import { setAlertModalState } from "../../common/data/actions";


const modifyCashBankMap = (data) => {
    let singleObj = {}
    if (data && data !== undefined && data !== null && data[0].payment_mode !== "") {
        data.map((obj, index) => {
            const { payment_mode, deposit_bank_arr } = obj
            if (deposit_bank_arr.length === 1 && !deposit_bank_arr[0].deposit_bank) {
                const { bank_ledger, ledger_code } = deposit_bank_arr[0]
                singleObj[payment_mode] = [bank_ledger, ledger_code]
            } else {
                let subArr = deposit_bank_arr.map(deposit => {
                    const { deposit_bank, bank_ledger, ledger_code } = deposit;
                    return { [deposit_bank]: [bank_ledger, ledger_code] };
                });
                subArr.unshift("DEPOSIT_BANK")
                singleObj[payment_mode] = subArr
            }
        });

    }
    return singleObj

}

export function saveSegmapFunction(values, toggles, setSavedSegmapId, dispatch, props) {
    const { cust: custToggle, ws: wsToggle, transType: transTypeToggle, loc: locToggle, cashBankMap: cashBankMapToggle } = toggles;
    userACL.atCreate(values)
    let saveObj = cloneDeep(values)
    const cashBankMap = modifyCashBankMap(saveObj.cash_bank_map)
    // values.cash_bank_map = Object.keys(cashBankMap).length > 0 ? JSON.stringify(cashBankMap) : null
    delete saveObj.seperateWsToggle
    delete saveObj.bussinessCustGroupToggle
    delete saveObj.locToggle
    delete saveObj.cashBankMapToggle
    delete saveObj.transTypeToggle
    saveObj.segid = (saveObj.segid === "" || saveObj.segid === undefined || saveObj.segid === null) ? null : saveObj.segid
    saveObj.ci_segid = (saveObj.ci_segid === "" || saveObj.ci_segid === undefined || saveObj.ci_segid === null) ? null : saveObj.ci_segid
    saveObj.stpi_segid = (saveObj.stpi_segid === "" || saveObj.stpi_segid === undefined || saveObj.stpi_segid === null) ? null : saveObj.stpi_segid
    saveObj.pp_segid = (saveObj.pp_segid === "" || saveObj.pp_segid === undefined || saveObj.pp_segid === null) ? null : saveObj.pp_segid
    saveObj.ew_segid = (saveObj.ew_segid === "" || saveObj.ew_segid === undefined || saveObj.ew_segid === null) ? null : saveObj.ew_segid
    saveObj.wi_segid = (saveObj.wi_segid === "" || saveObj.wi_segid === undefined || saveObj.wi_segid === null) ? null : saveObj.wi_segid
    saveObj.r_segid = (saveObj.r_segid === "" || saveObj.r_segid === undefined || saveObj.r_segid === null) ? null : saveObj.r_segid
    saveObj.wi_bndp_segid = (saveObj.wi_bndp_segid === "" || saveObj.wi_bndp_segid === undefined || saveObj.wi_bndp_segid === null) ? null : saveObj.wi_bndp_segid
    saveObj.ccpccpc_segid = (saveObj.ccpccpc_segid === "" || saveObj.ccpccpc_segid === undefined || saveObj.ccpccpc_segid === null) ? null : saveObj.ccpccpc_segid
    saveObj.cid = (saveObj.cid === "" || saveObj.cid === undefined || saveObj.cid === null) ? null : saveObj.cid

    if (cashBankMapToggle === "no") {
        saveObj.cash_bank_map = null
    } else {
        saveObj.cash_bank_map = Object.keys(cashBankMap).length > 0 ? JSON.stringify(cashBankMap) : null
    }

    if (saveObj.vs_post_from_ci !== undefined && saveObj.vs_post_from_ci !== null && saveObj.vs_post_from_ci !== "") {
        saveObj.vs_post_from_ci = (saveObj.vs_post_from_ci === "y") ? 1 : 0
    } else {
        saveObj.vs_post_from_ci = 0
    }

    if (transTypeToggle === "no") {
        saveObj.wi_sl_pur_ledger = null
        saveObj.wi_sl_pur_ledger_cd = null
        saveObj.ci_sl_pur_ledger = null
        saveObj.ci_sl_pur_ledger_cd = null
        saveObj.pp_sl_pur_ledger = null
        saveObj.pp_sl_pur_ledger_cd = null
        saveObj.ew_sl_pur_ledger = null
        saveObj.ew_sl_pur_ledger_cd = null
        saveObj.ewc_sl_pur_ledger = null
        saveObj.ewc_sl_pur_ledger_cd = null
        saveObj.ccp_sl_pur_ledger = null
        saveObj.ccp_sl_pur_ledger_cd = null
        saveObj.ccpc_sl_pur_ledger = null
        saveObj.ccpc_sl_pur_ledger_cd = null
    }
    if (custToggle === "no") {
        saveObj.cust_group_vh = null
        saveObj.cust_group_ws = null
        saveObj.cust_group_tv = null

        if (wsToggle === "no") {
            saveObj.ci_segid = null
            saveObj.ci_godown = null
            saveObj.stpi_segid = null
            saveObj.stpi_segLedger = null
            saveObj.stpi_seg_ledger_cd = null
            saveObj.stpi_godown = null
            saveObj.pp_segid = null
            saveObj.pp_godown = null
            saveObj.ew_segid = null
            saveObj.wi_segid = null
            saveObj.wi_godown = null
            saveObj.r_segid = null
            saveObj.wi_bndp_segid = null
            saveObj.wi_bndp_godown = null
            saveObj.wi_cost_center = null
            saveObj.wi_bndp_cost_center = null
            dispatch(createSegmap(saveObj))
            setSavedSegmapId(saveObj.id)
        } else {
            saveObj.cust_group_vh = null
            saveObj.cust_group_ws = null
            saveObj.cust_group_tv = null
            dispatch(createSegmap(saveObj))
            setSavedSegmapId(saveObj.id)
        }

    } else {
        if (wsToggle === "no") {
            saveObj.ci_segid = null
            saveObj.ci_godown = null
            saveObj.stpi_segid = null
            saveObj.stpi_segLedger = null
            saveObj.stpi_seg_ledger_cd = null
            saveObj.stpi_godown = null
            saveObj.pp_segid = null
            saveObj.pp_godown = null
            saveObj.ew_segid = null
            saveObj.wi_segid = null
            saveObj.wi_godown = null
            saveObj.r_segid = null
            saveObj.wi_bndp_segid = null
            saveObj.wi_bndp_godown = null
            saveObj.wi_cost_center = null
            saveObj.wi_bndp_cost_center = null
            dispatch(createSegmap(saveObj))
            setSavedSegmapId(saveObj.id)
        } else {
            saveObj.ci_segid = (values.ci_segid === "") ? null : values.ci_segid
            saveObj.stpi_segid = (values.stpi_segid === "") ? null : values.stpi_segid
            saveObj.pp_segid = (values.pp_segid === "") ? null : values.pp_segid
            saveObj.ew_segid = (values.ew_segid === "") ? null : values.ew_segid
            saveObj.wi_segid = (values.wi_segid === "") ? null : values.wi_segid
            saveObj.r_segid = (values.r_segid === "" || values.r_segid === undefined || values.r_segid === null) ? null : values.r_segid
            saveObj.wi_bndp_segid = (values.wi_bndp_segid === "" || values.wi_bndp_segid === undefined || values.wi_bndp_segid === null) ? null : parseInt(values.wi_bndp_segid)
            saveObj.wi_bndp_godown = (values.wi_bndp_godown === "" || values.wi_bndp_godown === undefined || values.wi_bndp_godown === null) ? null : values.wi_bndp_godown
            saveObj.wi_cost_center = (values.wi_cost_center === "" || values.wi_cost_center === undefined || values.wi_cost_center === null) ? null : values.wi_cost_center
            saveObj.wi_bndp_cost_center = (values.wi_bndp_cost_center === "" || values.wi_bndp_cost_center === undefined || values.wi_bndp_cost_center === null) ? null : values.wi_bndp_cost_center
            dispatch(createSegmap(saveObj))
            setSavedSegmapId(saveObj.id)
        }

    }
}

export function editSegmapFunction(values, toggles, setSavedSegmapId, dispatch, props) {
    const { cust: custToggle, ws: wsToggle, transType: transTypeToggle, loc: locToggle, cashBankMap: cashBankMapToggle } = toggles;
    userACL.atUpdate(values)
    let editObj = cloneDeep(values)
    delete editObj.seperateWsToggle
    delete editObj.bussinessCustGroupToggle
    delete editObj.locToggle
    delete editObj.cashBankMapToggle
    delete editObj.transTypeToggle
    let cashBankMap = modifyCashBankMap(editObj.cash_bank_map)

    editObj.loc_nature = (editObj.loc_nature === "") ? null : editObj.loc_nature

    editObj.segid = (editObj.segid === "" || editObj.segid === undefined || editObj.segid === null) ? null : editObj.segid
    editObj.cid = (editObj.cid === "" || editObj.cid === undefined || editObj.cid === null) ? null : editObj.cid

    editObj.ci_segid = (editObj.ci_segid === "" || editObj.ci_segid === undefined || editObj.ci_segid === null) ? null : editObj.ci_segid
    editObj.stpi_segid = (editObj.stpi_segid === "" || editObj.stpi_segid === undefined || editObj.stpi_segid === null) ? null : editObj.stpi_segid
    editObj.pp_segid = (editObj.pp_segid === "" || editObj.pp_segid === undefined || editObj.pp_segid === null) ? null : editObj.pp_segid
    editObj.ew_segid = (editObj.ew_segid === "" || editObj.ew_segid === undefined || editObj.ew_segid === null) ? null : editObj.ew_segid
    editObj.wi_segid = (editObj.wi_segid === "" || editObj.wi_segid === undefined || editObj.wi_segid === null) ? null : editObj.wi_segid
    editObj.r_segid = (editObj.r_segid === "" || editObj.r_segid === undefined || editObj.r_segid === null) ? null : editObj.r_segid
    editObj.wi_bndp_segid = (editObj.wi_bndp_segid === "" || editObj.wi_bndp_segid === undefined || editObj.wi_bndp_segid === null) ? null : editObj.wi_bndp_segid
    editObj.ccpccpc_segid = (editObj.ccpccpc_segid === "" || editObj.ccpccpc_segid === undefined || editObj.ccpccpc_segid === null) ? null : editObj.ccpccpc_segid


    if (locToggle === "no") {
        editObj.loc_nature = null
    } else {
        editObj.loc_nature = (editObj.loc_nature === "") ? null : editObj.loc_nature
    }
    if (cashBankMapToggle === "no") {
        editObj.cash_bank_map = null
    } else {
        editObj.cash_bank_map = Object.keys(cashBankMap).length > 0 ? JSON.stringify(cashBankMap) : null
    }

    if (editObj.vs_post_from_ci !== undefined && editObj.vs_post_from_ci !== null && editObj.vs_post_from_ci !== "") {
        editObj.vs_post_from_ci = (editObj.vs_post_from_ci === "y") ? 1 : 0
    } else {
        editObj.vs_post_from_ci = 0
    }

    if (transTypeToggle === "no") {
        editObj.wi_sl_pur_ledger = null
        editObj.wi_sl_pur_ledger_cd = null
        editObj.ci_sl_pur_ledger = null
        editObj.ci_sl_pur_ledger_cd = null
        editObj.pp_sl_pur_ledger = null
        editObj.pp_sl_pur_ledger_cd = null
        editObj.ew_sl_pur_ledger = null
        editObj.ew_sl_pur_ledger_cd = null
        editObj.ewc_sl_pur_ledger = null
        editObj.ewc_sl_pur_ledger_cd = null
        editObj.ccp_sl_pur_ledger = null
        editObj.ccp_sl_pur_ledger_cd = null
        editObj.ccpc_sl_pur_ledger = null
        editObj.ccpc_sl_pur_ledger_cd = null
    }
    if (custToggle === "no") {
        editObj.cust_group_vh = null
        editObj.cust_group_ws = null
        editObj.cust_group_tv = null

        if (wsToggle === "no") {
            editObj.ci_segid = null
            editObj.ci_godown = null
            editObj.stpi_segid = null
            editObj.stpi_segLedger = null
            editObj.stpi_seg_ledger_cd = null
            editObj.stpi_godown = null
            editObj.pp_segid = null
            editObj.pp_godown = null
            editObj.ew_segid = null
            editObj.wi_segid = null
            editObj.wi_godown = null
            editObj.r_segid = null
            editObj.wi_bndp_segid = null
            editObj.wi_bndp_godown = null
            editObj.wi_cost_center = null
            editObj.wi_bndp_cost_center = null
            dispatch(editSegmap(editObj))
            setSavedSegmapId(editObj.id)
        } else {
            editObj.cust_group_vh = null
            editObj.cust_group_ws = null
            editObj.cust_group_tv = null
            editObj.ci_segid = (values.ci_segid === "") ? null : values.ci_segid
            editObj.stpi_segid = (values.stpi_segid === "") ? null : values.stpi_segid
            editObj.pp_segid = (values.pp_segid === "") ? null : values.pp_segid
            editObj.ew_segid = (values.ew_segid === "") ? null : values.ew_segid
            editObj.wi_segid = (values.wi_segid === "") ? null : values.wi_segid
            editObj.r_segid = (values.r_segid === "" || values.r_segid === undefined || values.r_segid === null) ? null : values.r_segid
            editObj.wi_bndp_segid = (values.wi_bndp_segid === "" || values.wi_bndp_segid === undefined || values.wi_bndp_segid === null) ? null : parseInt(values.wi_bndp_segid)
            editObj.wi_bndp_godown = (values.wi_bndp_godown === "" || values.wi_bndp_godown === undefined || values.wi_bndp_godown === null) ? null : values.wi_bndp_godown
            editObj.wi_cost_center = (values.wi_cost_center === "" || values.wi_cost_center === undefined || values.wi_cost_center === null) ? null : values.wi_cost_center
            editObj.wi_bndp_cost_center = (values.wi_bndp_cost_center === "" || values.wi_bndp_cost_center === undefined || values.wi_bndp_cost_center === null) ? null : values.wi_bndp_cost_center
            dispatch(editSegmap(editObj))
            setSavedSegmapId(editObj.id)
        }

    } else {
        if (wsToggle === "no") {
            editObj.ci_segid = null
            editObj.ci_godown = null
            editObj.stpi_segid = null
            editObj.stpi_segLedger = null
            editObj.stpi_seg_ledger_cd = null
            editObj.stpi_godown = null
            editObj.pp_segid = null
            editObj.pp_godown = null
            editObj.ew_segid = null
            editObj.wi_segid = null
            editObj.wi_godown = null
            editObj.r_segid = null
            editObj.wi_bndp_segid = null
            editObj.wi_bndp_godown = null
            editObj.wi_cost_center = null
            editObj.wi_bndp_cost_center = null
            dispatch(editSegmap(editObj))
            setSavedSegmapId(editObj.id)
        } else {
            editObj.ci_segid = (values.ci_segid === "") ? null : values.ci_segid
            editObj.stpi_segid = (values.stpi_segid === "") ? null : values.stpi_segid
            editObj.pp_segid = (values.pp_segid === "") ? null : values.pp_segid
            editObj.ew_segid = (values.ew_segid === "") ? null : values.ew_segid
            editObj.wi_segid = (values.wi_segid === "") ? null : values.wi_segid
            editObj.r_segid = (values.r_segid === "" || values.r_segid === undefined || values.r_segid === null) ? null : values.r_segid
            editObj.wi_bndp_segid = (values.wi_bndp_segid === "" || values.wi_bndp_segid === undefined || values.wi_bndp_segid === null) ? null : parseInt(values.wi_bndp_segid)
            editObj.wi_bndp_godown = (values.wi_bndp_godown === "" || values.wi_bndp_godown === undefined || values.wi_bndp_godown === null) ? null : values.wi_bndp_godown
            editObj.wi_cost_center = (values.wi_cost_center === "" || values.wi_cost_center === undefined || values.wi_cost_center === null) ? null : values.wi_cost_center
            editObj.wi_bndp_cost_center = (values.wi_bndp_cost_center === "" || values.wi_bndp_cost_center === undefined || values.wi_bndp_cost_center === null) ? null : values.wi_bndp_cost_center
            dispatch(editSegmap(editObj))
            setSavedSegmapId(editObj.id)
        }
    }
    // console.log(values, '======edit-values')
    setTimeout(function () {
        props.history.push(`/segmap/list`)
    }, 2000)
}

export function cloneSegmapFunction(values, toggles, setSavedSegmapId, dispatch, props, segmapData) {
    const { cust: custToggle, ws: wsToggle, transType: transTypeToggle, loc: locToggle, cashBankMap: cashBankMapToggle } = toggles;
    userACL.atCreate(values)
    let cloneObj = cloneDeep(values)
    let parentGroup = cloneObj.parent_group
    let mul = cloneObj.mul_dealer_cd
    let outlet = cloneObj.outlet_cd
    let loc = cloneObj.loc_cd
    let dealerCd = cloneObj.dealer_for_cd
    let cid = cloneObj.cid

    cloneObj.segid = (cloneObj.segid === "" || cloneObj.segid === undefined || cloneObj.segid === null) ? null : cloneObj.segid
    cloneObj.cid = (cloneObj.cid === "" || cloneObj.cid === undefined || cloneObj.cid === null) ? null : cloneObj.cid

    cloneObj.ci_segid = (cloneObj.ci_segid === "" || cloneObj.ci_segid === undefined || cloneObj.ci_segid === null) ? null : cloneObj.ci_segid
    cloneObj.stpi_segid = (cloneObj.stpi_segid === "" || cloneObj.stpi_segid === undefined || cloneObj.stpi_segid === null) ? null : cloneObj.stpi_segid
    cloneObj.pp_segid = (cloneObj.pp_segid === "" || cloneObj.pp_segid === undefined || cloneObj.pp_segid === null) ? null : cloneObj.pp_segid
    cloneObj.ew_segid = (cloneObj.ew_segid === "" || cloneObj.ew_segid === undefined || cloneObj.ew_segid === null) ? null : cloneObj.ew_segid
    cloneObj.wi_segid = (cloneObj.wi_segid === "" || cloneObj.wi_segid === undefined || cloneObj.wi_segid === null) ? null : cloneObj.wi_segid
    cloneObj.r_segid = (cloneObj.r_segid === "" || cloneObj.r_segid === undefined || cloneObj.r_segid === null) ? null : cloneObj.r_segid
    cloneObj.wi_bndp_segid = (cloneObj.wi_bndp_segid === "" || cloneObj.wi_bndp_segid === undefined || cloneObj.wi_bndp_segid === null) ? null : cloneObj.wi_bndp_segid
    cloneObj.ccpccpc_segid = (cloneObj.ccpccpc_segid === "" || cloneObj.ccpccpc_segid === undefined || cloneObj.ccpccpc_segid === null) ? null : cloneObj.ccpccpc_segid

    let isClone = segmapData.map((item) => {
        if (item.parent_group === parentGroup &&
            item.mul_dealer_cd === mul &&
            item.outlet_cd === outlet &&
            item.loc_cd === loc &&
            item.dealer_for_cd === dealerCd &&
            item.cid === cid
        ) {
            return true
        } else {
            return false
        }
    }).every(item => item === false)

    if (isClone && isClone !== null && isClone !== undefined) {
        let cashBankMap = modifyCashBankMap(cloneObj.cash_bank_map)
        cloneObj.id = v4()
        delete cloneObj.seperateWsToggle
        delete cloneObj.bussinessCustGroupToggle
        delete cloneObj.locToggle
        delete cloneObj.cashBankMapToggle
        delete cloneObj.transTypeToggle
        if (cashBankMapToggle === "no") {
            cloneObj.cash_bank_map = null
        } else {
            cloneObj.cash_bank_map = Object.keys(cashBankMap).length > 0 ? JSON.stringify(cashBankMap) : null
        }

        if (cloneObj.vs_post_from_ci !== undefined && cloneObj.vs_post_from_ci !== null && cloneObj.vs_post_from_ci !== "") {
            cloneObj.vs_post_from_ci = (cloneObj.vs_post_from_ci === "y") ? 1 : 0
        } else {
            cloneObj.vs_post_from_ci = 0
        }

        if (transTypeToggle === "no") {
            cloneObj.wi_sl_pur_ledger = null
            cloneObj.wi_sl_pur_ledger_cd = null
            cloneObj.ci_sl_pur_ledger = null
            cloneObj.ci_sl_pur_ledger_cd = null
            cloneObj.pp_sl_pur_ledger = null
            cloneObj.pp_sl_pur_ledger_cd = null
            cloneObj.ew_sl_pur_ledger = null
            cloneObj.ew_sl_pur_ledger_cd = null
            cloneObj.ewc_sl_pur_ledger = null
            cloneObj.ewc_sl_pur_ledger_cd = null
            cloneObj.ccp_sl_pur_ledger = null
            cloneObj.ccp_sl_pur_ledger_cd = null
            cloneObj.ccpc_sl_pur_ledger = null
            cloneObj.ccpc_sl_pur_ledger_cd = null
        }
        if (custToggle === "no") {
            cloneObj.cust_group_vh = null
            cloneObj.cust_group_ws = null
            cloneObj.cust_group_tv = null

            if (wsToggle === "no") {
                cloneObj.ci_segid = null
                cloneObj.ci_godown = null
                cloneObj.stpi_segid = null
                cloneObj.stpi_segLedger = null
                cloneObj.stpi_seg_ledger_cd = null
                cloneObj.stpi_godown = null
                cloneObj.pp_segid = null
                cloneObj.pp_godown = null
                cloneObj.ew_segid = null
                cloneObj.wi_segid = null
                cloneObj.wi_godown = null
                cloneObj.r_segid = null
                cloneObj.wi_bndp_segid = null
                cloneObj.wi_bndp_godown = null
                cloneObj.wi_cost_center = null
                cloneObj.wi_bndp_cost_center = null
                dispatch(createSegmap(cloneObj))
                setSavedSegmapId(cloneObj.id)
            } else {
                cloneObj.cust_group_vh = null
                cloneObj.cust_group_ws = null
                cloneObj.cust_group_tv = null
                dispatch(createSegmap(cloneObj))
                setSavedSegmapId(cloneObj.id)
            }

        } else {
            if (wsToggle === "no") {
                cloneObj.ci_segid = null
                cloneObj.ci_godown = null
                cloneObj.stpi_segid = null
                cloneObj.stpi_segLedger = null
                cloneObj.stpi_seg_ledger_cd = null
                cloneObj.stpi_godown = null
                cloneObj.pp_segid = null
                cloneObj.pp_godown = null
                cloneObj.ew_segid = null
                cloneObj.wi_segid = null
                cloneObj.wi_godown = null
                cloneObj.r_segid = null
                cloneObj.wi_bndp_segid = null
                cloneObj.wi_bndp_godown = null
                cloneObj.wi_cost_center = null
                cloneObj.wi_bndp_cost_center = null
                dispatch(createSegmap(cloneObj))
                setSavedSegmapId(cloneObj.id)
            } else {
                cloneObj.ci_segid = (values.ci_segid === "") ? null : values.ci_segid
                cloneObj.stpi_segid = (values.stpi_segid === "") ? null : values.stpi_segid
                cloneObj.pp_segid = (values.pp_segid === "") ? null : values.pp_segid
                cloneObj.ew_segid = (values.ew_segid === "") ? null : values.ew_segid
                cloneObj.wi_segid = (values.wi_segid === "") ? null : values.wi_segid
                cloneObj.r_segid = (values.r_segid === "" || values.r_segid === undefined || values.r_segid === null) ? null : values.r_segid
                cloneObj.wi_bndp_segid = (values.wi_bndp_segid === "" || values.wi_bndp_segid === undefined || values.wi_bndp_segid === null) ? null : parseInt(values.wi_bndp_segid)
                cloneObj.wi_bndp_godown = (values.wi_bndp_godown === "" || values.wi_bndp_godown === undefined || values.wi_bndp_godown === null) ? null : values.wi_bndp_godown
                cloneObj.wi_cost_center = (values.wi_cost_center === "" || values.wi_cost_center === undefined || values.wi_cost_center === null) ? null : values.wi_cost_center
                cloneObj.wi_bndp_cost_center = (values.wi_bndp_cost_center === "" || values.wi_bndp_cost_center === undefined || values.wi_bndp_cost_center === null) ? null : values.wi_bndp_cost_center
                dispatch(createSegmap(cloneObj))
                setSavedSegmapId(values.id)
            }
        }
        setTimeout(function () {
            props.history.push(`/segmap/list`)
        }, 2000)
    } else {
        dispatch(setAlertModalState({ isOpen: true, title: 'Mapping Status', msg: 'Mapping Already Exists', type: 'error', size: 'mini' }))
    }
}

export function modifyCashBankMapForClone(data) {
    const convertedData = [];

    if (data && data !== "" && data !== undefined && data !== null && data !== "[object Object]") {

        let cashBankObject = JSON.parse(data)
        for (const [paymentMode, depositBanks] of Object.entries(cashBankObject)) {
            const depositBankArr = [];
            let depositBank = ""
            let bankLedger = ""
            let ledgerCode = ""

            if (Array.isArray(depositBanks)) {

                for (let i = 1; i < depositBanks.length; i++) {

                    const depositBankObj = depositBanks[i];

                    if (depositBankObj && depositBankObj !== null && depositBankObj !== undefined) {
                        if (typeof (depositBankObj) === "string") {
                            depositBank = "";
                            bankLedger = depositBanks[0];
                            ledgerCode = depositBanks[1];
                        } else {
                            depositBank = Object.keys(depositBankObj)[0];
                            bankLedger = depositBankObj[depositBank][0];
                            ledgerCode = depositBankObj[depositBank][1];
                        }

                    }

                    depositBankArr.push({
                        deposit_bank: depositBank,
                        bank_ledger: bankLedger,
                        ledger_code: ledgerCode
                    });
                }
            }
            // console.log('depositBankArr', depositBankArr)
            convertedData.push({
                payment_mode: paymentMode,
                deposit_bank_arr: depositBankArr
            });
        }

        return convertedData;
    } else {
        return convertedData;
    }
}

export function setTogglesForEdit(obj, setToggles) {
    if (!obj) return;

    const newToggles = {
        ws: 'no',
        cust: 'no',
        loc: 'no',
        transType: 'no',
        cashBankMap: 'no'
    };

    // Workshop toggle
    const wsFields = [
        obj.ci_segid, obj.ci_godown, obj.stpi_segid, obj.stpi_segLedger,
        obj.stpi_seg_ledger_cd, obj.stpi_godown, obj.pp_segid, obj.pp_godown,
        obj.ew_segid, obj.wi_segid, obj.r_segid, obj.wi_godown,
        obj.wi_bndp_segid, obj.wi_bndp_godown, obj.wi_cost_center, obj.wi_bndp_cost_center
    ];
    if (wsFields.some(field => field !== null && field !== '' && field !== undefined)) {
        newToggles.ws = 'yes';
    }

    // Customer toggle
    if ((obj.cust_group_vh && obj.cust_group_vh !== '') ||
        (obj.cust_group_ws && obj.cust_group_ws !== '') ||
        (obj.cust_group_tv && obj.cust_group_tv !== '')) {
        newToggles.cust = 'yes';
    }

    // Location toggle
    if (obj.loc_nature && obj.loc_nature !== '') {
        newToggles.loc = 'yes';
    }

    // Cash bank map toggle
    if (obj.cash_bank_map && obj.cash_bank_map.length > 0) {
        newToggles.cashBankMap = 'yes';
    }

    // Trans type toggle
    const transTypeFields = [
        obj.wi_sl_pur_ledger, obj.wi_sl_pur_ledger_cd,
        obj.ci_sl_pur_ledger, obj.ci_sl_pur_ledger_cd,
        obj.pp_sl_pur_ledger, obj.pp_sl_pur_ledger_cd,
        obj.ew_sl_pur_ledger, obj.ew_sl_pur_ledger_cd,
        obj.ewc_sl_pur_ledger, obj.ewc_sl_pur_ledger_cd,
        obj.ccp_sl_pur_ledger, obj.ccp_sl_pur_ledger_cd,
        obj.ccpc_sl_pur_ledger, obj.ccpc_sl_pur_ledger_cd
    ];
    if (transTypeFields.some(field => field && field !== '')) {
        newToggles.transType = 'yes';
    }

    setToggles(newToggles);
}